<script>
	// export let color = "#161616"
</script>

<svg
	data-svg-carbon-icon="Cube32"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
	viewBox="0 0 32 32"
	><path
		d="m28.5039 8.1362-12-7a1 1 0 0 0-1.0078 0l-12 7A1 1 0 0 0 3 9v14a1 1 0 0 0 .4961.8638l12 7a1 1 0 0 0 1.0078 0l12-7A1 1 0 0 0 29 23V9a1 1 0 0 0-.4961-.8638ZM16 3.1577 26.0156 9 16 14.8423 5.9844 9ZM5 10.7412l10 5.833v11.6846l-10-5.833Zm12 17.5176V16.5742l10-5.833v11.6846Z"
	/></svg
>
